import React, { useContext } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Button, VStack, Heading, chakra } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../types';

import DjangoInput from '../components/DjangoInput';
import DjangoForm from '../components/DjangoForm';
import OAuthOptions from '../components/OAuthOptions';
import { AuthContext } from '../../../context/AuthProvider';

const ChakraLink = chakra(Link);

const SignInPage: Page = () => {
  const { t } = useTranslation();
  const user = useContext(AuthContext);
  if (user && user.pk) {
    return <Navigate to="/" />;
  }
  return (
    <VStack
      spacing={0}
      gap={4}
      align="center"
      justify="center"
      minH="calc(100vh - 60px - 88px)"
      textAlign="center"
      mx="auto"
      maxW="500px"
      w="full"
      p={4}
    >
      <Heading as="h3" size="xl" color="blue.500" mb={8}>
        {t('signinPage.signIn')}
      </Heading>
      <DjangoForm w="full" method="post" action="">
        <input
          type="hidden"
          name="csrfmiddlewaretoken"
          value={document.getElementById('root')?.dataset.csrf}
        />
        <DjangoInput
          autoFocus
          autoComplete="off"
          name="username"
          label={t('signinPage.emailOrUsername')}
        />
        <DjangoInput
          name="password"
          type="password"
          showPasswordToggle
          label={t('general.password')}
          link={
            <ChakraLink
              color="slategray"
              // @ts-ignore
              to={'/password_reset/'}
              tabIndex={1}
            >
              {t('signinPage.ForgotPassword')}
            </ChakraLink>
          }
        />

        <Button colorScheme="blue" size="lg" w="full" type="submit">
          {t('signinPage.signIn')}
        </Button>
      </DjangoForm>
      <OAuthOptions pt={4} />
    </VStack>
  );
};

SignInPage.getRoute = () => '/sign-in/';

export default SignInPage;
